var TopicControlRegistrationParamsSerialiser = require('services/control/topic-control-registration-params-serialiser');
var ConversationIDSerialiser = require('conversation/conversation-id-serialiser');

var serialiser = {
    read : function(input) {
        var params = TopicControlRegistrationParamsSerialiser.read(input);
        var cid = ConversationIDSerialiser.read(input);

        return {
            params : params,
            cid : cid
        };
    },
    write : function(output, request) {
        TopicControlRegistrationParamsSerialiser.write(output, request.params);
        ConversationIDSerialiser.write(output, request.cid);
    }
};

module.exports = serialiser;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/control/topic-control-registration-request-serialiser.js
// module id = 1044
// module chunks = 1